import { define } from 'wicked-elements'

define('[data-component="sticky-navigation"]', {
  connected() {
    this.handleScroll = () => {
      const halfViewport = window.innerHeight / 2;
      if (window.scrollY > halfViewport) {
        this.element.style.position = 'fixed';
        this.element.style.top = '0';
        this.element.style.left = '0';
        this.element.style.right = '0';
        this.element.style.zIndex = '50';
      } else {
        this.element.style.position = 'absolute';
        this.element.style.top = '50%';
        this.element.style.left = '0';
        this.element.style.right = '0';
        this.element.style.zIndex = '';
      }
    };

    // Run once on init
    this.handleScroll();
    
    // Add scroll listener
    window.addEventListener('scroll', this.handleScroll);
  },
  
  disconnected() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});